var _path, _polyline, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M673.734,333.61H492.988c-3.232,0-5.862-2.63-5.862-5.862V64.475 c0-3.232,2.63-5.862,5.862-5.862h180.746c3.232,0,5.862,2.629,5.862,5.862v263.273 C679.596,330.98,676.966,333.61,673.734,333.61z M492.988,58.863c-3.095,0-5.612,2.518-5.612,5.612v263.273 c0,3.095,2.518,5.612,5.612,5.612h180.746c3.095,0,5.612-2.517,5.612-5.612V64.475c0-3.094-2.518-5.612-5.612-5.612H492.988z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M465.306,333.61H284.56c-3.232,0-5.862-2.63-5.862-5.862V64.475 c0-3.232,2.629-5.862,5.862-5.862h180.747c3.232,0,5.862,2.629,5.862,5.862v263.273 C471.168,330.98,468.538,333.61,465.306,333.61z M284.56,58.863c-3.094,0-5.612,2.518-5.612,5.612v263.273 c0,3.095,2.518,5.612,5.612,5.612h180.747c3.095,0,5.612-2.517,5.612-5.612V64.475c0-3.094-2.518-5.612-5.612-5.612H284.56z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M257.012,333.61H76.266c-3.232,0-5.862-2.63-5.862-5.862V64.475 c0-3.232,2.629-5.862,5.862-5.862h180.746c3.232,0,5.862,2.629,5.862,5.862v263.273 C262.875,330.98,260.245,333.61,257.012,333.61z M76.266,58.863c-3.094,0-5.612,2.518-5.612,5.612v263.273 c0,3.095,2.518,5.612,5.612,5.612h180.746c3.095,0,5.612-2.517,5.612-5.612V64.475c0-3.094-2.518-5.612-5.612-5.612H76.266z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 394.68,
    style: {
      fill: "#E0E0E0"
    },
    width: 750,
    height: 0.12
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 653.626,
    y: 424.056,
    style: {
      fill: "#EBEBEB"
    },
    width: 55.729,
    height: 0.421
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.044,
    y: 428.621,
    style: {
      fill: "#EBEBEB"
    },
    width: 14.627,
    height: 0.421
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.645,
    y: 411.258,
    style: {
      fill: "#EBEBEB"
    },
    width: 72.674,
    height: 0.421
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.299,
    y: 411.258,
    style: {
      fill: "#EBEBEB"
    },
    width: 10.656,
    height: 0.421
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.586,
    y: 418.362,
    style: {
      fill: "#EBEBEB"
    },
    width: 157.613,
    height: 0.421
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree-1--inject-2_00000034059146088656602340000013428581751181164172_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M306.309,173.755c-1.641-0.99-3.542-1.467-5.456-1.367c-1.175-1.427-0.228-3.573,0.911-5.024 c1.139-1.451,2.53-3.105,2.098-4.904c-0.672-2.698-4.461-2.806-7.194-2.278c-1.007-1.631-0.983-3.657-1.475-5.54 c-0.492-1.882-2.098-3.861-3.885-3.597c-1.786,0.264-2.89,2.242-4.652,2.662c-2.05,0.48-3.825-1.331-5.432-2.686 c-0.198-0.169-0.406-0.325-0.623-0.468l0,0c0.336-5.624,5.684-4.724,10.24-5.492c3.561-0.587-5.875-9.592,1.319-12.494 c1.394-0.383,2.616-1.229,3.465-2.398c0.746-1.82,0.085-3.914-1.571-4.976c-1.638-0.988-3.533-1.464-5.444-1.367 c-1.175-1.427-0.228-3.573,0.911-5.024s2.518-3.106,2.098-4.904c-0.684-2.698-4.46-2.806-7.194-2.278 c-1.007-1.631-0.983-3.657-1.475-5.539c-0.492-1.882-2.086-3.861-3.885-3.597c-1.799,0.264-2.89,2.242-4.652,2.662 c-2.05,0.479-3.825-1.331-5.432-2.686s-4.413-2.206-5.516-0.42c-0.66,1.055-0.264,2.542-0.959,3.597 c-1.187,1.799-4.029,0.695-5.779-0.6c-1.751-1.295-4.58-2.47-5.779-0.671c-0.313,0.589-0.542,1.219-0.684,1.871 c-0.171,0.464-0.409,0.901-0.707,1.295c-0.348-1.247-0.456-2.602-0.779-3.861c-0.492-1.871-2.086-3.861-3.885-3.597 c-1.799,0.264-2.89,2.254-4.652,2.662c-2.051,0.492-3.825-1.331-5.432-2.686c-1.607-1.355-4.413-2.206-5.516-0.408 c-0.659,1.055-0.264,2.542-0.959,3.597c-0.144,0.237-0.341,0.439-0.576,0.587c-0.611-0.12-1.211-0.12-1.811-0.12 c-1.175-1.415-0.228-3.549,0.911-5.012c1.139-1.463,2.53-3.118,2.098-4.904c-0.672-2.71-4.461-2.806-7.194-2.278 c-1.007-1.643-0.983-3.669-1.475-5.539c-0.492-1.871-2.086-3.873-3.885-3.597c-1.798,0.276-2.89,2.254-4.652,2.674 c-2.05,0.48-3.825-1.319-5.432-2.686c-1.607-1.367-4.413-2.206-5.516-0.42c-0.659,1.043-0.264,2.542-0.959,3.597 c-1.187,1.787-4.005,0.684-5.767-0.611c-1.763-1.295-4.592-2.47-5.792-0.671c-0.314,0.593-0.544,1.226-0.684,1.882 c-0.827,2.398-3.429,3.597-5.444,5.132c-2.014,1.535-3.609,4.592-1.907,6.463c0.839,0.935,2.326,1.283,2.746,2.482 c0.516,1.415-0.983,2.794-2.182,3.813c-1.571,1.744-2.034,4.221-1.199,6.415c-0.597,0.544-1.305,0.953-2.074,1.199 c-2.05,0.48-3.825-1.331-5.432-2.686c-1.607-1.355-4.413-2.206-5.516-0.42c-0.659,1.043-0.264,2.542-0.959,3.597 c-1.187,1.799-4.005,0.695-5.767-0.6c-1.763-1.295-4.592-2.47-5.792-0.671c-0.312,0.589-0.542,1.219-0.684,1.87 c-0.827,2.398-3.429,3.597-5.443,5.132c-2.014,1.535-3.609,4.592-1.907,6.475c0.803,0.935,2.194,1.319,2.674,2.398 c-1.415-0.564-3.046-0.42-3.705,0.635c-0.66,1.055-0.264,2.542-0.959,3.597c-1.187,1.799-4.005,0.695-5.768-0.6 c-1.762-1.295-4.592-2.47-5.791-0.671c-0.314,0.593-0.545,1.226-0.683,1.882c-0.827,2.398-3.429,3.573-5.444,5.12 s-3.609,4.604-1.906,6.475c0.839,0.923,2.326,1.283,2.746,2.482c0.528,1.415-0.971,2.794-2.17,3.813 c-1.99,1.679-2.35,6.727,0.276,8.118c1.103,0.575,2.746,0.875,2.986,1.966c0.24,1.091-0.863,1.93-1.595,2.77 c-0.169,0.217-0.321,0.448-0.454,0.689c-1.386,2.518-0.469,5.682,2.049,7.068c0.635,0.288,1.403,0.54,1.643,1.199 c0.09,0.493,0.036,1.001-0.156,1.463c-0.252,0.917-0.337,1.871-0.252,2.818c0,0.326,0.124,0.639,0.348,0.875 c0.24,0.172,0.532,0.257,0.827,0.24c3.789,0.168,5.611-1.175,7.926,2.122c0.202,0.332,0.472,0.618,0.791,0.839 c0.324,0.162,0.681,0.248,1.043,0.252c2.602,0.216,4.281-1.403,6.679-1.715c3.321-0.42,4.005,1.283,6.919,2.65 c4.568,2.158,6.787,0.827,7.65-2.29c0.227-0.883,0.364-1.787,0.408-2.698c-0.02-1.375,0.563-2.689,1.595-3.597h0.072 c2.434,0.204,4.077-1.187,6.211-1.619l1.355-0.144c2.53-0.024,3.369,1.499,5.995,2.698c1.208,0.637,2.544,0.993,3.909,1.043 c0.384,1.415-1.007,2.686-2.206,3.669c-1.978,1.691-2.338,6.739,0.288,8.118c1.091,0.575,2.746,0.899,2.986,1.978 c0.24,1.079-0.863,1.93-1.595,2.758c-0.168,0.215-0.318,0.443-0.45,0.682c-1.392,2.522-0.477,5.695,2.045,7.087 c0.624,0.3,1.403,0.54,1.631,1.199c0.101,0.495,0.051,1.009-0.144,1.475c-0.263,0.91-0.349,1.863-0.252,2.806 c-0.004,0.328,0.116,0.645,0.336,0.887c0.247,0.167,0.542,0.247,0.839,0.228c3.789,0.168,5.611-1.175,7.926,2.122 c0.196,0.337,0.466,0.624,0.791,0.839c0.325,0.16,0.681,0.25,1.043,0.264c2.602,0.216,4.281-1.415,6.679-1.715 c3.309-0.42,4.005,1.283,6.906,2.65c4.58,2.146,6.799,0.827,7.662-2.29c0.228-0.887,0.365-1.795,0.408-2.71 c0.336-5.611,5.684-4.724,10.252-5.48c0.322-0.025,0.606-0.223,0.743-0.516h0.288c2.602,0.216,4.281-1.403,6.679-1.715 c3.321-0.42,4.005,1.283,6.918,2.65c4.568,2.158,6.787,0.827,7.65-2.29c0.228-0.887,0.365-1.795,0.408-2.71 c0.3-4.365,3.597-4.796,7.194-5.132c0.114,1.727,1.112,3.273,2.638,4.089c0.635,0.288,1.403,0.539,1.643,1.199 c0.09,0.492,0.036,1.001-0.156,1.463c-0.251,0.913-0.336,1.863-0.252,2.806c-0.004,0.327,0.116,0.645,0.336,0.887 c0.248,0.165,0.541,0.249,0.839,0.24c3.789,0.168,5.612-1.175,7.926,2.122c0.202,0.332,0.472,0.618,0.791,0.839 c0.324,0.162,0.681,0.248,1.043,0.252c2.602,0.216,4.281-1.403,6.679-1.715c3.321-0.42,4.005,1.283,6.918,2.65 c4.568,2.158,6.787,0.827,7.65-2.29c0.227-0.883,0.364-1.787,0.408-2.698c0.336-5.624,5.696-4.724,10.252-5.492 c3.561-0.588-5.887-9.592,1.307-12.494c1.394-0.383,2.616-1.229,3.465-2.398C308.435,176.798,307.833,174.828,306.309,173.755z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M173.871,207.268c-1.364-0.83-2.948-1.228-4.543-1.142c-0.977-1.193-0.178-2.969,0.761-4.187 c0.939-1.218,2.106-2.538,1.738-4.086c-0.533-2.258-3.692-2.335-5.964-1.891c-0.85-1.37-0.825-3.07-1.269-4.619 c-0.444-1.548-1.65-3.172-3.236-2.982c-1.586,0.19-2.411,1.878-3.883,2.221c-1.7,0.406-3.185-1.104-4.517-2.233 c-1.332-1.129-3.68-1.84-4.606-0.355c-0.546,0.888-0.216,2.144-0.787,3.02c-1.002,1.523-3.35,0.571-4.822-0.508 c-1.472-1.078-3.807-2.056-4.822-0.558c-0.256,0.494-0.448,1.018-0.571,1.561c-0.685,2.005-2.842,2.994-4.53,4.276 c-1.688,1.281-3.02,3.807-1.586,5.393c0.698,0.774,1.929,1.091,2.284,2.068c0.431,1.269-0.825,2.335-1.814,3.172 c-1.65,1.408-1.954,5.621,0.228,6.763c0.926,0.482,2.271,0.634,2.538,1.649c0.266,1.015-0.711,1.611-1.269,2.309 c-1.469,1.894-1.124,4.62,0.77,6.089c0.177,0.138,0.366,0.261,0.562,0.37c0.52,0.254,1.167,0.457,1.358,1.015 c0.094,0.426,0.05,0.87-0.127,1.269c-0.212,0.759-0.281,1.551-0.203,2.335c-0.006,0.272,0.094,0.536,0.279,0.736 c0.203,0.145,0.449,0.216,0.698,0.203c3.147,0.14,4.669-0.977,6.598,1.764c0.169,0.276,0.393,0.514,0.66,0.698 c0.272,0.135,0.571,0.209,0.875,0.216c2.17,0.178,3.578-1.167,5.57-1.421c2.741-0.355,3.324,1.066,5.748,2.208 c3.807,1.789,5.672,0.685,6.344-1.916c0.189-0.735,0.303-1.488,0.343-2.246c0.279-4.682,4.745-3.946,8.539-4.581 c2.969-0.495-4.885-7.981,1.091-10.405c1.17-0.315,2.193-1.029,2.893-2.017C175.847,209.922,175.282,208.148,173.871,207.268z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M231.891,181.397l4.889-15.507l9.52-12.244l-1.626-1.357l-8.981,9.789l-1.596-15.507h-2.6 c0,0,2.136,18.423-0.937,25.169c0,0-11.161,28.396-17.956,34.543c-0.385,0.356-0.72,0.762-0.998,1.207 c-2.038-5.227-4.687-10.194-7.893-14.798c2.684-6.865,8.442-21.953,10.398-30.025c1.533-6.271,2.683-12.629,3.443-19.039 l-2.226-0.245c0,0-6.315,29.821-16.753,43.392c-3.092-2.841-6.598-5.197-10.398-6.985c-0.848-4.191-1.207-11.485,1.567-22.871 l-2.206-0.564c0,0-4.21,9.634-3.841,21.199c-1.57-0.789-3.084-1.686-4.53-2.684c-10.058-7.075-17.133-19.857-17.133-19.857 l-2.059,2.004c0,0,8.585,18.852,20.549,25.148c11.964,6.296,19.717,21.643,20.336,25.665c0.169,1.148,1.552,10.259-0.364,26.223 c-12.731-5.431-37.958-20.387-39.635-21.765l-2.937,3.949l40.815,29.205c0.639,38.916-2.302,79.406-2.193,88.167h23.768 c-0.585-12.085-5.593-57.528-3.37-105.024c0.189-1.167,0.389-2.505,0.579-4.061c1.856-14.569,12.912-34.474,18.171-40.134 c5.635-6.065,11.899-10.874,11.899-10.874l-1.446-3.101L231.891,181.397z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M420.025,61.104c0-3.109-2.521-5.63-5.63-5.63l0,0c-0.546-0.002-1.089,0.079-1.61,0.24 c0.08-0.573,0.12-1.151,0.12-1.73c0-6.583-5.337-11.92-11.92-11.92c-0.735,0-1.468,0.067-2.19,0.2 c-2.992-4.916-9.403-6.476-14.318-3.484c-3.062,1.863-4.951,5.17-5.002,8.754h-0.18c-5.305,0.171-9.466,4.61-9.295,9.915 c0.163,5.064,4.231,9.132,9.295,9.295h35.26C417.608,66.663,420.037,64.158,420.025,61.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M510.583,117.03c0-2.885-2.339-5.223-5.223-5.223l0,0c-0.506-0.002-1.01,0.073-1.494,0.223 c0.075-0.532,0.112-1.068,0.111-1.605c0-6.108-4.951-11.059-11.059-11.059c-0.681,0-1.362,0.062-2.032,0.186 c-2.776-4.561-8.723-6.008-13.284-3.232c-2.841,1.729-4.593,4.796-4.64,8.121h-0.167c-4.921,0.159-8.782,4.277-8.624,9.199 c0.152,4.698,3.925,8.472,8.624,8.624h32.713C508.341,122.187,510.594,119.864,510.583,117.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M210.606,43.317c0-1.734-1.406-3.14-3.14-3.14l0,0c-0.305-0.001-0.607,0.044-0.898,0.134 c0.045-0.32,0.067-0.642,0.067-0.965c0-3.672-2.977-6.649-6.649-6.649c-0.41,0-0.818,0.037-1.221,0.112 c-1.669-2.742-5.245-3.612-7.987-1.943c-1.708,1.039-2.762,2.884-2.79,4.883h-0.1c-2.959,0.096-5.28,2.572-5.185,5.53 c0.091,2.825,2.36,5.093,5.185,5.185h19.668C209.258,46.417,210.613,45.02,210.606,43.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M666.969,60.852c0-3.023-2.451-5.474-5.474-5.474l0,0c-0.531-0.002-1.058,0.076-1.565,0.233 c0.078-0.557,0.117-1.119,0.117-1.682c0-6.401-5.189-11.59-11.59-11.59c-0.714,0-1.427,0.065-2.129,0.194 c-2.909-4.78-9.142-6.296-13.922-3.387c-2.977,1.812-4.814,5.027-4.863,8.511h-0.175c-5.158,0.166-9.204,4.483-9.038,9.64 c0.159,4.924,4.114,8.879,9.038,9.038h34.283C664.618,66.257,666.98,63.822,666.969,60.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M372.642,127.368c0-3.418-2.771-6.189-6.189-6.189l0,0c-0.6-0.003-1.197,0.086-1.77,0.264 c0.089-0.63,0.133-1.266,0.132-1.902c0-7.237-5.866-13.103-13.103-13.103c-0.808,0-1.613,0.074-2.407,0.22 c-3.289-5.404-10.336-7.118-15.74-3.83c-3.366,2.049-5.442,5.683-5.498,9.623h-0.198c-5.831,0.188-10.406,5.068-10.218,10.899 c0.18,5.567,4.651,10.038,10.218,10.218h38.76C369.985,133.478,372.655,130.725,372.642,127.368z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Streetlight--inject-81"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M612.918,333.284h6.451V103.056c-0.01-11.566-9.383-20.939-20.949-20.949h-5.696v6.451h5.696 c8.003,0.01,14.487,6.495,14.498,14.497V333.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M551.426,90.006h46.442l-1.06-7.005c-0.355-2.35-2.202-4.194-4.553-4.544 c-3.06-0.452-7.069-0.995-8.949-1.032c-5.484-0.12-19.041,1.299-25.659,2.046c-2.24,0.261-4.079,1.891-4.608,4.083 L551.426,90.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M556.338,94.909h36.626c2.708,0,4.903-2.195,4.903-4.903l0,0h-46.442 C551.431,92.715,553.629,94.909,556.338,94.909z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#E0E0E0",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 582.144,
    y1: 105.099,
    x2: 590.854,
    y2: 125.646
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M573.609,105.099c0,11.863-0.726,21.729-0.726,33.593"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 566.346,
    y1: 104.191,
    x2: 553.635,
    y2: 120.896
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background_simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M311.133,57.528c-21.564,2.847-42.358,8.907-60.801,18.414 c-21.736,11.204-43.946,28.659-37.386,51.49c12.11,42.149,70.207,42.917,58.607,71.257c-13.139,32.102-4.328,69.757,54.63,80.228 c111.982,19.889,247.351-96.484,209.331-160.43C511.844,78.676,425.634,42.414,311.133,57.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M311.133,57.528c-21.564,2.847-42.358,8.907-60.801,18.414 c-21.736,11.204-43.946,28.659-37.386,51.49c12.11,42.149,70.207,42.917,58.607,71.257c-13.139,32.102-4.328,69.757,54.63,80.228 c111.982,19.889,247.351-96.484,209.331-160.43C511.844,78.676,425.634,42.414,311.133,57.528z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M637.6,451.633c0,3.387-117.57,6.132-262.6,6.132s-262.6-2.745-262.6-6.132 c0-3.387,117.57-6.132,262.6-6.132S637.6,448.246,637.6,451.633z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M156.624,315.213H65.77c-9.403,0-17.025-7.623-17.025-17.026V86.926 c0-7.255,5.881-13.136,13.136-13.136h98.632c7.255,0,13.136,5.881,13.136,13.136v211.262 C173.649,307.59,166.027,315.213,156.624,315.213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M137.088,79.206l-1.999,3.95H86.214l-2.907-3.95H60.202c-3.697,0-6.694,2.961-6.694,6.615v212.97 c0,5.52,4.528,9.995,10.114,9.995h95.148c5.586,0,10.114-4.475,10.114-9.995V85.821c0-3.653-2.997-6.615-6.693-6.615H137.088z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 109.13,
    cy: 78.83,
    r: 2.01
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M114.107,78.83c0,0.555-0.45,1.005-1.005,1.005c-0.555,0-1.005-0.45-1.005-1.005 s0.45-1.005,1.005-1.005C113.658,77.825,114.107,78.275,114.107,78.83z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M162.191,79.206h-25.103l-1.999,3.95H86.214l-2.907-3.95H60.202c-3.697,0-6.694,2.961-6.694,6.615 v54.489h115.375V85.821C168.884,82.167,165.888,79.206,162.191,79.206z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-5_00000179620518408695073040000003636825638790214076_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.054,
    y: 84.136,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 1.525,
    height: 2.034
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.558,
    y: 83.458,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 1.525,
    height: 2.712
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.078,
    y: 82.78,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 1.525,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.597,
    y: 82.11,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 1.525,
    height: 4.068
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.029,
    y: 83.396,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 0.901,
    height: 2.034
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.554,
    y: 82.657,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 7.203,
    height: 3.521
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.64,
    y: 131.185,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 115.198,
    height: 170.583
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M168.839,157.429v-8.542l-27.094,24.982l-28.621-9.53l17.932-33.162 h-7.215l-7.645,14.119l-55.45-14.119h-7.087v4.589l20.867,5.295l-16.935,29.827l39.731,9.345l-4.718,8.719l-38.963-9.769v6.389 l35.909,9.001l-11.622,21.505l-18.352-5.154l-5.935,3.733v7.413l6.968-4.412l14.292,4.006l-21.26,39.322v13.343l13.908-25.714 l18.919,5.365v23.473l38.486,24.318h12.648l-44.733-28.201v-17.781l75.97,21.532v-6.442l-22.668-6.451l6.931-36.842l15.783,3.989 v-6.38L126.3,214.417l18.892-35.139L168.839,157.429z M67.21,166.783l13.716-24.073l32.261,8.224l-12.802,23.658L67.21,166.783z  M146.847,226.013l-6.858,36.692l-69.423-19.678l19.44-35.96l7.443,7.942l23.382,4.412L146.847,226.013z M119.835,212.953 l-19.029-3.609l-7.617-8.154l16.935-31.318l27.872,9.283L119.835,212.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M148.838,121.661H82c-2.374,0.004-4.302-1.917-4.307-4.291 c0-0.003,0-0.005,0-0.008l0,0c0-2.374,1.925-4.299,4.299-4.299c0.002,0,0.005,0,0.008,0h66.838 c2.374,0.008,4.292,1.94,4.284,4.314c0,0.008,0,0.016,0,0.023l0,0C153.1,119.754,151.191,121.653,148.838,121.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M72.47,114.319L72.47,114.319c-1.287-1.286-3.373-1.286-4.661,0l0,0 c-1.261,1.283-1.261,3.34,0,4.622l2.311,2.311l2.311-2.311C73.703,117.669,73.72,115.613,72.47,114.319z M71.176,117.686 c-0.572,0.571-1.499,0.57-2.07-0.002c-0.571-0.572-0.57-1.499,0.002-2.07c0.571-0.57,1.496-0.57,2.068,0 c0.581,0.568,0.591,1.5,0.022,2.081c-0.007,0.007-0.015,0.015-0.022,0.022V117.686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M142.366,261.425c-2.399,0-4.344,1.877-4.344,4.192s1.945,4.192,4.344,4.192 s4.343-1.877,4.343-4.192l0,0C146.71,263.302,144.765,261.425,142.366,261.425z M142.366,268.344 c-1.561,0-2.826-1.221-2.826-2.727c0-1.506,1.265-2.727,2.826-2.727s2.826,1.221,2.826,2.727l0,0 C145.192,267.123,143.927,268.344,142.366,268.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M144.085,265.617c0,0.916-0.77,1.659-1.719,1.659s-1.719-0.743-1.719-1.659 c0-0.916,0.77-1.659,1.719-1.659S144.085,264.701,144.085,265.617L144.085,265.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M127.498,145.887l-9.144,17.058l23.4,6.927l12.912-12.901 C145.386,153.809,136.314,150.107,127.498,145.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M168.839,131.176v11.648l-11.449,11.472 c-7.699-2.647-15.298-5.507-22.696-8.824c-1.878-0.835-3.734-1.703-5.569-2.603l6.236-11.692H168.839z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "111.24,173.64 132.966,180.708 122.103,202.646  100.047,195.807  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M132.984,211.408c0.183-0.591,10.671-21.54,10.671-21.54 l15.545,4.668l2.743,23.694L132.984,211.408z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "147.464,185.673 163.744,189.868 165.047,172.035  150.351,179.795  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M101.163,243.9c0.329-0.265,7.544-21.726,7.544-21.726 l33.66,5.718l-5.605,28.653L101.163,243.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M83.048,231.634l10.15,3.23l-5.075,9.036 c0,0-10.689-2.365-10.689-3.062C77.434,240.141,83.048,231.634,83.048,231.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M83.606,258.813c-0.247,0.583-6.413,42.955-6.413,42.955 H53.64l0.704-14.426L68.6,255.681L83.606,258.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M168.839,279.727v17.89l-25.745,0.982l-22.383-16.092 c0,0,3.851-10.697,5.003-14.103L168.839,279.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M122.267,267.47l-19.331-5.083l-2.743,9.169l17.493,9.138 C117.687,280.694,122.267,268.344,122.267,267.47z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "168.839,243.018 168.839,262.555 151.053,258.813  154.674,240.317  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "62.4,205.575 68.042,193.133 83.752,197.598  77.433,210.596  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "76.711,162.291 84.456,148.746 105.469,154.632  98.419,169.095  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M118.701,131.176c-1.948,3.803-4.462,8.63-4.865,8.939 c-0.402,0.309-26.381-6.045-37.866-8.939H118.701z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "68.033,144.775 53.64,173.798 53.64,141.166  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M144.094,260.578h-0.165c-0.493-0.085-0.824-0.538-0.741-1.015l6.255-34.848 c-4.426-1.306-27.35-7.942-49.516-11.56c-0.199-0.03-0.382-0.123-0.521-0.265l-10.543-11.039c-0.26-0.27-0.318-0.668-0.146-0.997 l12.235-22.732l-38.716-8.454c-0.492-0.109-0.799-0.583-0.686-1.058c0.019-0.081,0.05-0.158,0.092-0.23l13.021-22.944 c0.252-0.429,0.817-0.579,1.262-0.335c0.444,0.244,0.6,0.789,0.347,1.218l-12.482,21.92l38.689,8.454 c0.493,0.105,0.804,0.576,0.695,1.052c-0.017,0.076-0.045,0.15-0.083,0.219l-12.491,23.182l9.903,10.333 c24.58,4.024,49.964,11.719,50.22,11.798c0.433,0.134,0.698,0.555,0.622,0.988l-6.355,35.571 C144.919,260.262,144.541,260.575,144.094,260.578z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M79.614,134.035L79.614,134.035c-1.932-1.949-5.078-1.962-7.027-0.03 c-0.01,0.01-0.02,0.02-0.03,0.03l0,0c-1.915,1.94-1.915,5.059,0,6.998l3.499,3.499l3.499-3.499 C81.487,139.109,81.513,135.99,79.614,134.035z M77.654,139.108c-0.87,0.87-2.28,0.871-3.15,0.001 c-0.87-0.87-0.871-2.28-0.001-3.151c0.87-0.87,2.28-0.871,3.151-0.001c0,0.001,0.001,0.001,0.001,0.001 C78.523,136.829,78.523,138.238,77.654,139.108z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M135.358,157.482H93.343c-2.08,0-3.765-1.686-3.765-3.765v-14.302c0-2.08,1.686-3.766,3.765-3.766 h42.015c2.08,0,3.765,1.686,3.765,3.766v14.302C139.123,155.796,137.437,157.482,135.358,157.482z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 101.194,
    cy: 143.214,
    r: 3.01
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M101.194,146.575c-2.655,0-4.808,2.152-4.808,4.808h9.616 C106.002,148.727,103.85,146.575,101.194,146.575z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M114.641,146.224c1.662,0,3.01-1.348,3.01-3.01s-1.348-3.01-3.01-3.01 c-1.663,0-3.01,1.348-3.01,3.01S112.979,146.224,114.641,146.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M114.641,146.575c-2.655,0-4.808,2.152-4.808,4.808h9.616 C119.449,148.727,117.297,146.575,114.641,146.575z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 -53.2415 206.7467)",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 128.089,
    cy: 143.214,
    rx: 3.01,
    ry: 3.01
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M128.089,146.575 c-2.655,0-4.808,2.152-4.808,4.808h9.616C132.896,148.727,130.744,146.575,128.089,146.575z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M91.882,135.649h-8.624c0,0,7.224,5.805,7.389,5.805S91.882,135.649,91.882,135.649z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M83.606,301.768c-0.741,0,5.844-14.124,5.801-14.399 c-0.18-1.134,24.309,14.399,24.309,14.399H83.606z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "GPS_Icon"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M372.659,104.553c14.928-14.373,38.682-13.923,53.055,1.006 c13.987,14.527,13.99,37.511,0.008,52.042l-21.196,21.199c-2.942,2.943-7.713,2.943-10.656,0l-21.211-21.211 C358.023,142.939,358.023,119.202,372.659,104.553z M399.195,148.517c9.894,0,17.862-8.248,17.402-18.243 c-0.408-8.871-7.708-16.171-16.579-16.579c-9.995-0.46-18.243,7.508-18.243,17.402c0,0.001,0,0.003,0,0.004 c0.019,9.607,7.813,17.385,17.421,17.385V148.517z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeMiterlimit: 10
    },
    points: "435.803,139.391 596.067,139.391 596.067,176.224  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 596.067,
    cy: 174.17,
    r: 3.989
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8676 -0.4973 0.4973 0.8676 24.637 366.6363)",
    style: {
      fill: "#407BFF"
    },
    cx: 700.781,
    cy: 137.055,
    rx: 20.089,
    ry: 20.089
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "687.339,145.402 682.2,144.824 680.085,150.996 686.495,150.674  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M717.105,119.15c5.305,3.811,8.469,10.42,8.112,16.942"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M724.947,139.077c0.019,0.996-0.17,1.996-0.551,2.916"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M701.284,137.144c2.225,0,4.029-1.804,4.029-4.029c0-2.225-1.804-4.029-4.029-4.029 c-2.225,0-4.029,1.804-4.029,4.029C697.255,135.34,699.059,137.144,701.284,137.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M701.284,137.613c-3.554,0-6.435,2.881-6.435,6.435h12.87 C707.719,140.493,704.838,137.613,701.284,137.613z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3692 -0.9294 0.9294 0.3692 13.7458 368.5909)",
    style: {
      fill: "#407BFF"
    },
    cx: 278.384,
    cy: 174.17,
    rx: 20.089,
    ry: 20.089
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "286.27,187.794 284.883,192.776 290.641,195.844 291.341,189.465  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M294.708,156.265c5.305,3.811,8.47,10.42,8.112,16.942"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M302.55,176.192c0.019,0.996-0.169,1.996-0.551,2.916"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 278.384,
    cy: 170.718,
    r: 4.029
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M278.384,175.216c-3.554,0-6.435,2.881-6.435,6.435h12.87 C284.819,178.097,281.938,175.216,278.384,175.216z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M705.797,393.361l9.847-7.754c6.278,7.148,11.342,14.269,15.166,18.521l-2.374,5.574l-6.413-1.287 C722.023,408.416,715.215,401.12,705.797,393.361z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M715.229,403.629l3.83-2.44c3.92,1.983,4.702,0.401,5.183-3.12 c1.028-0.837,2.139,0.247,2.448,0.532l6.906,6.247c0.584,0.517,0.638,1.41,0.12,1.993c-0.092,0.104-0.199,0.194-0.317,0.266 c-3.382,2.154-4.982,3.174-9.191,5.855l-12.873,8.201c-3.509,2.236-6.489-0.838-5.252-2.086 c5.585-5.577,8.97-10.422,9.774-13.593C716.018,404.916,715.477,404.912,715.229,403.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M714.665,407.009c1.043-0.48,2.298-0.474,3.335,0.017"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M713.764,409.415c1.043-0.48,2.298-0.474,3.336,0.017"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M712.308,411.882c1.043-0.48,2.298-0.474,3.336,0.017"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M733.716,406.841c-0.092,0.104-0.199,0.194-0.317,0.266 c-3.382,2.154-4.982,3.174-9.191,5.855l-12.873,8.201c-1.899,1.21-3.636,0.861-4.641,0.092 c0.537-0.336,26.244-16.434,26.509-16.763l0.502,0.474C734.178,405.493,734.196,406.299,733.716,406.841z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M647.728,393.081l15.258,9.409c-1.134,11.446-3.947,21.85-2.887,27.469l-4.923,3.531l-6.706-6.991 C648.47,426.499,649.046,406.015,647.728,393.081z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M647.865,421.442l4.54-0.097c2.321,3.73,3.81,2.784,6.049,0.025 c1.313-0.181,1.7,1.322,1.816,1.725l2.659,8.924c0.23,0.745-0.187,1.536-0.932,1.766c-0.133,0.041-0.27,0.062-0.409,0.063 c-4.009,0.085-5.906,0.126-10.896,0.232l-15.26,0.325c-4.16,0.089-5.111-4.085-3.406-4.51 c7.669-1.866,13.077-4.25,15.411-6.542C647.871,422.952,647.411,422.668,647.865,421.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M645.628,424.038c1.141,0.131,2.21,0.788,2.842,1.746"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M643.609,425.626c1.14,0.131,2.21,0.788,2.842,1.746"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M641.084,426.979c1.141,0.131,2.21,0.788,2.842,1.746"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M661.997,433.786c-0.133,0.041-0.27,0.062-0.409,0.063 c-4.009,0.085-5.906,0.126-10.896,0.232l-15.26,0.325c-2.251,0.048-3.555-1.152-4.014-2.331 c0.633-0.009,30.962-0.419,31.359-0.562l0.183,0.666C663.092,432.874,662.69,433.572,661.997,433.786z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M668.349,174.471c0,0-1.711-5.638,0.091-16.161c-0.002-0.011-0.565-0.188-0.567-0.199 c0.246-1.471,0.531-2.837,0.81-4.025c0.006-0.034,0.004-0.045,0.004-0.045l-12.964,10.19c0.696,3.221,0.238,9.65-0.159,12.388 c0,0-1.215,5.015,5.214,4.501C665.477,180.744,668.349,174.471,668.349,174.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M656.003,168.839l7.817-2.715c-0.446,2.577-2.319,5.784-7.874,6.656 C655.946,172.78,656.187,169.925,656.003,168.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M668.03,147.258c0.059,8.942,0.273,13.985-3.925,18.821 c-6.315,7.275-17.339,4.029-20.076-4.742c-2.464-7.894-2.147-21.192,6.352-25.247 C658.754,132.095,667.97,138.315,668.03,147.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M668.43,136.473c-1.557-4.824-13.86-4.04-17.124-1.299c-0.488,0.41,7.046,3.573,6.593,3.442 l3.511,0.953c0.52-0.153,1.6,0.393,2.249,1.998c0,0,0.539,13.68,4.677,17.369c3.006-1.728,2.819-7.152,3.58-10.441 C673.05,143.595,674.331,136.443,668.43,136.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M672.052,154.442c-0.556,2.341-2.146,4.198-3.853,5.196c-2.568,1.501-3.756-1.337-3.696-4.16 c0.055-2.541,0.582-5.667,3.473-6.017C670.825,149.117,672.687,151.765,672.052,154.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M655.458,150.697c0.062,0.911-0.372,1.678-0.969,1.713c-0.597,0.035-1.131-0.676-1.193-1.587 c-0.062-0.911,0.372-1.678,0.968-1.713C654.862,149.075,655.396,149.785,655.458,150.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M646.533,151.483c0.062,0.911-0.371,1.678-0.968,1.713c-0.597,0.035-1.131-0.676-1.194-1.587 c-0.062-0.911,0.372-1.678,0.968-1.713C645.936,149.861,646.471,150.572,646.533,151.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A24E3F"
    },
    d: "M649.406,150.78c0,0-2.576,4.725-3.376,6.631c1.346,1.059,3.495,0.382,3.495,0.382 L649.406,150.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M657.393,146.25c-0.134,0.066-0.299,0.06-0.432-0.031c-1.586-1.072-3.049-0.488-3.064-0.483 c-0.218,0.09-0.47-0.013-0.562-0.23c-0.092-0.217,0.011-0.466,0.228-0.556c0.077-0.032,1.91-0.764,3.877,0.567 c0.197,0.133,0.248,0.398,0.116,0.592C657.514,146.171,657.457,146.218,657.393,146.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M652.71,160.494c1.479-0.089,2.575-0.905,3.645-2.084"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M669.85,152.118c-0.395-0.507-1.14-0.653-1.752-0.457s-1.099,0.676-1.444,1.219c-0.414,0.651-0.654,1.412-0.688,2.183"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M642.327,147.905c-0.08-0.012-0.158-0.046-0.224-0.105c-0.177-0.158-0.194-0.429-0.038-0.605 c1.563-1.765,3.507-1.469,3.595-1.467c0.233,0.037,0.394,0.256,0.36,0.489c-0.034,0.233-0.249,0.392-0.48,0.358 c-0.081-0.016-1.58-0.224-2.835,1.193C642.607,147.879,642.464,147.925,642.327,147.905z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M669.992,132.478c-0.831-1.936-3.451-2.158-5.376-1.585c-0.114-2.442-3.402-3.578-5.393-3.344 c-2.073,0.244-2.748,1.139-2.748,1.139c0.163,0.02-0.732-1.152-1.263-1.602c-1.961-1.661-4.861-1.967-7.053-0.743 s-3.55,3.906-3.302,6.524c-1.402-1.205-3.709-0.956-4.809,0.519c-1.1,1.475-0.787,3.899,0.653,5.054 c-1.518,0.225-2.655,1.941-2.335,3.526c0.32,1.584,2.031,2.712,3.514,2.316c0.247,1.793,0.633,4.025,0.88,5.817l1.832-6.826 c1.201-0.547,1.388-1.132,1.521-2.507c1.057,1.622,2.472,1.361,4.311,1.131c1.839-0.23,3.487-1.614,4.101-3.444 c1.109,1.693,3.038,2.885,4.965,2.673c1.927-0.212,3.645-2.071,3.461-4.105c1.291,1.639,3.757,2.087,5.456,0.99 C670.108,136.914,670.824,134.414,669.992,132.478z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M683.534,173.904c0,0,7.953,0.218,11.15,9.09c2.944,8.169,10.432,26.181,10.432,26.181 l-17.903,5.243l-7.128-21.329L683.534,173.904z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M654.286,258.979l10.793,23.03c0,0-17.137,51.591-18.167,56.968 c-1.03,5.377-1.508,73.119-1.508,73.119l19.069,0.03l7.476-66.082c0,0,23.156-56.124,24.854-60.688 c3.176-8.538-0.155-20.024-0.155-20.024l-5.897-8.501L654.286,258.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M643.814,270.527c0,2.095,7.439,73.555,8.66,73.811c1.221,0.256,55.113,59.197,55.113,59.197 l15.303-13.437l-39.542-53.614l-4.379-48.179l-1.534-30.285l-34.488,2.549L643.814,270.527z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4
    },
    points: "669.969,362.976 670.92,346.194 681.999,321.643 681.999,321.643 673.682,347.598  672.888,365.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4
    },
    points: "649.987,328.044 665.079,282.009 659.824,277.208 661.493,283.811 649.333,322.576  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M597.829,196.279l23.35,21.433l10.884-20.259c0,0,11.875,11.725,11.47,11.898 c-0.405,0.173-13.979,29.894-23.769,24.561c-9.79-5.333-26.344-32.148-26.344-32.148L597.829,196.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M621.179,217.711c0,0,2.024,3.239,1.772,6.294 c0,0,0.906-1.497,0.632-3.93c-0.274-2.433-1.461-4.117-1.461-4.117L621.179,217.711z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M642.674,179.224c6.374,3.271,8.933,14.89-4.766,42.904l-16.361-12.623 c2.624-6.99,5.286-10.629,9.482-19.115C637.682,177.218,642.674,179.224,642.674,179.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M642.47,178.798c4.497-0.997,22.377-5.679,41.504-4.877l10.103,71.24 c0,0,1.963,9.335,4.648,18.594c-18.213,10.547-43.493,12.248-57.057,6.494c0.18,0.284-0.246-7.606-0.829-19.169 c-1.027-20.375-2.538-52.153-2.067-70.696C638.79,179.926,642.022,178.898,642.47,178.798z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "639.388,219.027 638.746,195.986 635.837,220.53  637.908,222.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "688.214,214.126 687.213,214.419 680.692,196.947  685.584,216.941 688.909,216.958  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M600.082,199.992c0,0,1.791-2.83,1.152-5.524c-0.639-2.694-0.432-5.016-1.045-6.986 c-0.613-1.97-1.725,0.583-2.042,2.061c-0.317,1.478-0.69,3.15-1.762,2.733c-1.072-0.417-7.283-8.117-8.835-8.526 c-1.552-0.41-0.937,1.15-0.937,1.15s-1.559-1.829-2.452-1.409c-0.232,0.109-0.594,0.739-0.014,1.684 c1.304,2.126,4.271,6.447,4.271,6.447c-0.165-0.251-4.208-5.323-4.913-6.004c-0.921-0.889-1.809-0.839-2.307-0.288 c-0.709,0.784,4.089,7.243,4.101,7.657c0,0-2.638-3.811-3.995-3.668c-1.356,0.143,0.173,2.632,1.939,4.571 c1.619,1.777,4.329,5.688,6.15,7.335c2.244,2.03,4.206,2.889,6.81,1.76C598.806,201.855,600.082,199.992,600.082,199.992z "
  }))))))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M586.864,185.1c1.212,1.497,2.357,3.05,3.428,4.652"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M586.272,194.501c1.455-2.019,3.517-3.596,5.847-4.471"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M596.067,193.476c-0.685,0.748-1.099,1.74-1.148,2.753c-0.05,1.013,0.264,2.04,0.872,2.852"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M703.771,209.57c0,0,5.386,12.759,7.673,24.208c1.039,5.204-3.12,8.539-7.373,9.567 c-13.401,3.238-43.598,3.249-43.598,3.249l-0.791-9.211l34.782-7.526l-6.25-15.732L703.771,209.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M660.397,248.555l-11.401,1.286c-0.39,0.044-0.778-0.091-1.057-0.366l-17.351-17.154 c-0.716-0.708-0.387-1.926,0.588-2.178l10.026-2.586c0.441-0.114,0.909,0.012,1.234,0.332l18.727,18.454 C661.938,247.109,661.48,248.433,660.397,248.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M661.463,237.432c0,0-0.322-1.341-5.365-2.88c-3.832-1.169-7.638-4.755-8.256-4.632 c-0.618,0.124-1.295,2.075,0.299,3.801c1.595,1.725,3.244,2.698,2.823,3.357c-1.014,1.589-13.484,0.295-13.699,1.656 c-0.215,1.361,2.162,5.256,8.839,7.861c6.677,2.604,15.83-0.008,15.83-0.008L661.463,237.432z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "598.544,389.055 72.689,401.381 72.689,311.441 603.603,311.441  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      enableBackground: "new"
    },
    points: "598.544,389.055 72.689,401.381 72.689,311.441  603.603,311.441  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M52.464,334.517v45.614c-0.003,9.772,6.364,18.404,15.701,21.285l3.717,1.13 c2.289,0.71,4.678,1.041,7.073,0.982l24.559-0.573c-2.917-10.207-3.174-20.991-0.746-31.326 c7.859-33.45,41.347-54.196,74.798-46.337c33.45,7.859,54.196,41.347,46.337,74.797l249.897-5.943 c-0.404-2.919-0.601-5.864-0.588-8.811c0.15-34.361,28.126-62.094,62.487-61.945c34.361,0.15,62.095,28.126,61.945,62.487 c0,1.212-0.098,2.407-0.098,3.602c0.327-0.131,0.671-0.262,0.999-0.426l8.547-3.815c8.429-3.808,13.848-12.199,13.851-21.448 v-92.899c0.001-8.738-4.841-16.758-12.574-20.826l-64.23-33.777c-0.735-0.392-1.301-1.041-1.588-1.823 c-0.645-1.757,0.256-3.704,2.013-4.35l7.859-2.816c0.659-0.227,1.133-0.807,1.223-1.499c0.13-1.004-0.579-1.924-1.583-2.054 c-30.519-4.257-149.221-19.778-211.618-12.149c-71.975,8.809-140.953,71.271-140.953,71.271 c-52.966-1.981-102.412,16.455-123.696,25.705c-6.872,3-12.158,8.761-14.555,15.865l-7.286,21.579 C53,328.753,52.497,331.622,52.464,334.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M473.866,394.147c-0.362-2.741-0.543-5.503-0.54-8.268c0-1.408,0.049-2.8,0.131-4.191 l-45.189-18.485c-2.645-1.077-5.5-1.541-8.35-1.359l-157.178,10.315c-2.569,0.162-5.078,0.853-7.368,2.03l-29.864,15.358 c-0.213,3.551-0.722,7.078-1.523,10.544L473.866,394.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M620.958,363.791v-2.374l-25.558,7.826c1.49,5.419,2.245,11.014,2.243,16.635 c0,1.212-0.098,2.407-0.098,3.602c0.327-0.131,0.671-0.262,0.999-0.426l8.563-3.815 C615.536,381.432,620.955,373.041,620.958,363.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M59.717,396.504c2.439,2.256,5.355,3.934,8.53,4.912l3.717,1.13 c2.289,0.71,4.678,1.041,7.073,0.982l24.559-0.573c-0.889-3.104-1.53-6.274-1.916-9.48L59.717,396.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M535.591,317.817c-2.824-0.001-5.646,0.174-8.449,0.525 c-37.291,4.657-63.746,38.662-59.089,75.953l5.894-0.147c-0.405-2.919-0.601-5.864-0.588-8.811 c0.15-34.361,28.126-62.094,62.487-61.945c34.361,0.15,62.094,28.126,61.945,62.487c0,1.212-0.098,2.407-0.098,3.602 c0.327-0.131,0.671-0.262,0.999-0.426l4.912-2.227c0-0.328,0-0.639,0-0.95c-0.045-37.577-30.501-68.025-68.078-68.062 L535.591,317.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M163.422,317.817c-5.813-0.001-11.601,0.742-17.225,2.211 c-36.368,9.504-58.146,46.69-48.642,83.058l6.041-0.131c-2.917-10.207-3.174-20.991-0.745-31.326 c7.859-33.45,41.347-54.196,74.798-46.337c33.45,7.859,54.196,41.347,46.337,74.798l6.025-0.147 c0.98-4.635,1.474-9.359,1.473-14.096C231.474,348.266,201.002,317.808,163.422,317.817L163.422,317.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M222.649,265.485c-0.727,0.616-1.245,1.501-1.462,2.503c-0.515,2.374,0.753,4.766,2.833,5.343 l25.977,7.281c2.301,0.652,4.688,0.832,7.049,0.532l192.607-23.863c4.687-0.595,9.057-3.02,12.367-6.863l25.267-29.436 c0.842-0.973,1.375-2.237,1.514-3.592c0.345-3.35-1.756-6.372-4.693-6.75c-46.122-6.116-104.436-11.676-141.26-7.177 C294.587,209.354,245.998,245.631,222.649,265.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M223.517,265.485c-0.728,0.616-1.245,1.501-1.462,2.503 c-0.515,2.374,0.753,4.766,2.833,5.343l25.977,7.281c2.301,0.652,4.688,0.832,7.048,0.532l188.296-12.907 c4.687-0.595,11.932-9.209,17.055-16.202l24.889-31.052c0.842-0.973,1.375-2.237,1.514-3.592 c0.345-3.35-1.756-6.372-4.693-6.75c-46.122-6.116-104.436-11.676-141.26-7.177 C295.455,209.354,246.867,245.631,223.517,265.485z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.339,283.836c-1.233-0.444-1.873-1.805-1.429-3.038l0,0c0.546-1.527,1.965-2.57,3.586-2.636l22.922-0.966 c0.31-0.014,0.619,0.033,0.911,0.137c1.243,0.444,1.891,1.812,1.446,3.056l0,0c-0.556,1.527-1.978,2.568-3.602,2.636 l-22.922,0.95C349.941,283.988,349.631,283.941,349.339,283.836z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M519.804,218.163c-2.027,1.803-2.209,4.908-0.406,6.935l5.436,5.911 c0.624,0.663,1.416,1.144,2.292,1.392l66.588,18.468c1.159,0.313,2.353,0.472,3.553,0.475h13.229 c-0.688-0.459-1.392-0.884-2.128-1.277l-64.23-33.81c-0.001-0.001-0.003-0.001-0.004-0.002 c-1.622-0.801-2.287-2.764-1.486-4.386l-20.859,5.223C521.053,217.29,520.374,217.657,519.804,218.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M105.16,297.267l-22.72-2.474l-13.053,5.339 c-2.744,1.123-4.794,3.479-5.525,6.353l0,0c-0.428,1.662-0.188,3.426,0.671,4.912l0.229,0.393 c1.46,2.513,4.292,3.897,7.171,3.504l13.098-1.801c1.277-0.183,2.487-0.684,3.52-1.457l15.112-11.461L105.16,297.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M199.54,262.837l3.618,1.031c2.812,0.802,5.838,0.151,8.072-1.736 c21.055-17.814,57.665-45.14,97.172-57.878c0.175-0.058,0.323-0.179,0.413-0.339c0.199-0.355,0.073-0.804-0.282-1.003 l-4.912-2.521C246.628,220.153,199.54,262.837,199.54,262.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M199.54,262.837l3.618,1.031 c2.812,0.802,5.838,0.151,8.072-1.736c21.055-17.814,57.665-45.14,97.172-57.878c0.175-0.058,0.323-0.179,0.413-0.339 c0.199-0.355,0.073-0.804-0.282-1.003l-4.912-2.521C246.628,220.153,199.54,262.837,199.54,262.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M415.464,286.888l-191.479,13.693l3.604,23.615 c1.104,7.235,3.786,14.138,7.856,20.22l16.004,23.918l163.427-22.095l77.263-59.351H415.464z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238"
    },
    cx: 535.531,
    cy: 385.872,
    r: 51.836
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    cx: 535.531,
    cy: 385.872,
    r: 31.779
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M538.08,359.829v16.291c0,1.402-1.136,2.538-2.538,2.538h-0.016 c-1.402,0-2.538-1.136-2.538-2.538v-16.291c0-1.402,1.136-2.538,2.538-2.538h0.016 C536.943,357.291,538.08,358.427,538.08,359.829z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M538.08,395.636v16.291c0,1.402-1.136,2.538-2.538,2.538h-0.016 c-1.402,0-2.538-1.136-2.538-2.538v-16.291c0-1.402,1.136-2.538,2.538-2.538h0.016 C536.943,393.099,538.08,394.235,538.08,395.636z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M545.241,383.208c-1.218,0.694-2.767,0.27-3.461-0.948l0,0 c-0.001-0.002-0.003-0.004-0.004-0.007c-0.698-1.215-0.278-2.767,0.937-3.465l14.097-8.186 c1.221-0.704,2.782-0.287,3.487,0.933l0,0c0.693,1.217,0.277,2.766-0.933,3.471l-14.097,8.186 C545.259,383.198,545.25,383.203,545.241,383.208z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M514.234,401.043c-1.215,0.698-2.767,0.278-3.464-0.937l0,0 c-0.001-0.002-0.003-0.004-0.004-0.007c-0.698-1.215-0.278-2.767,0.937-3.465l14.097-8.186c0,0,0.001,0,0.001-0.001 c1.212-0.705,2.765-0.294,3.47,0.918l0,0c0.707,1.217,0.297,2.776-0.917,3.487l-14.113,8.186 C514.239,401.041,514.236,401.042,514.234,401.043z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M556.81,401.105l-14.097-8.186c-1.22-0.706-1.638-2.266-0.933-3.487l0,0 c0.711-1.214,2.271-1.624,3.487-0.917l14.097,8.186c1.21,0.705,1.627,2.254,0.933,3.471l0,0 C559.592,401.392,558.031,401.809,556.81,401.105z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M529.267,382.266c-0.702,1.213-2.254,1.628-3.467,0.927l-14.097-8.186 c-0.002-0.001-0.004-0.003-0.007-0.004c-1.213-0.702-1.628-2.254-0.927-3.467l0,0c0.001-0.002,0.003-0.004,0.004-0.007 c0.702-1.213,2.254-1.628,3.467-0.927l14.113,8.186c0.001,0,0.001,0.001,0.001,0.001c1.211,0.705,1.621,2.259,0.916,3.47l0,0 C529.27,382.262,529.268,382.264,529.267,382.266z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M531.268,385.862c0-2.351,1.906-4.257,4.257-4.257c0.005,0,0.011,0,0.016,0 c2.36,0,4.273,1.913,4.273,4.273s-1.913,4.273-4.273,4.273s-4.273-1.913-4.273-4.273 C531.268,385.873,531.268,385.867,531.268,385.862z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238"
    },
    cx: 163.42,
    cy: 385.881,
    r: 51.836
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    cx: 163.42,
    cy: 385.881,
    r: 31.78
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M165.96,359.829v16.291c0,1.402-1.136,2.538-2.538,2.538h-0.016 c-1.402,0-2.538-1.136-2.538-2.538v-16.291c0-1.402,1.136-2.538,2.538-2.538h0.016 C164.823,357.291,165.96,358.427,165.96,359.829z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M165.96,395.636v16.291c0,1.402-1.136,2.538-2.538,2.538h-0.016 c-1.402,0-2.538-1.136-2.538-2.538v-16.291c0-1.402,1.136-2.538,2.538-2.538h0.016 C164.823,393.099,165.96,394.235,165.96,395.636z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M173.112,383.213c-1.212,0.686-2.751,0.259-3.436-0.953l0,0c0,0-0.001-0.001-0.001-0.001 c-0.705-1.212-0.294-2.765,0.918-3.47l14.113-8.186c0.002-0.001,0.004-0.002,0.007-0.004c1.215-0.698,2.767-0.279,3.465,0.937 l0,0c0.001,0.002,0.002,0.004,0.004,0.007c0.698,1.215,0.279,2.767-0.937,3.465l-14.097,8.186 C173.135,383.2,173.124,383.207,173.112,383.213z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M138.65,400.106L138.65,400.106c-0.001-0.002-0.003-0.004-0.004-0.007 c-0.698-1.215-0.278-2.767,0.937-3.465l14.097-8.186c1.216-0.707,2.776-0.297,3.487,0.917l0,0 c0.704,1.221,0.287,2.782-0.933,3.487l-14.097,8.186C140.916,401.744,139.355,401.326,138.65,400.106z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M188.173,400.178c-0.701,1.213-2.254,1.628-3.467,0.927l-14.113-8.186 c-1.214-0.711-1.624-2.271-0.917-3.487l0,0c0,0,0.001-0.001,0.001-0.001c0.706-1.211,2.259-1.621,3.47-0.916l14.097,8.186 c0.002,0.001,0.004,0.003,0.007,0.004c1.213,0.702,1.628,2.254,0.927,3.467l0,0 C188.176,400.174,188.175,400.176,188.173,400.178z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M157.152,382.286c-0.708,1.209-2.263,1.616-3.472,0.907l-14.097-8.186 c-0.002-0.001-0.004-0.003-0.006-0.004c-1.213-0.702-1.628-2.254-0.927-3.467l0,0c0.706-1.22,2.267-1.638,3.487-0.933 l14.097,8.186c0.002,0.001,0.004,0.003,0.007,0.004c1.213,0.702,1.628,2.254,0.927,3.467l0,0 C157.162,382.268,157.157,382.277,157.152,382.286z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M163.422,381.605L163.422,381.605c2.36,0,4.273,1.913,4.273,4.273 c0,2.36-1.913,4.273-4.273,4.273c-2.36,0-4.273-1.913-4.273-4.273C159.148,383.518,161.062,381.605,163.422,381.605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M615.519,288.085c1.727-0.538,2.691-2.373,2.153-4.1 c-0.601-10.912-2.921-20.629-9.611-27.31c-0.448-1.469-1.858-2.429-3.389-2.309l-39.507,3.733 c-0.688,0.074-1.334,0.363-1.847,0.827c-1.341,1.213-1.445,3.284-0.233,4.625L574.4,275.75c0.393,0.422,0.89,0.732,1.441,0.901 l37.821,11.461C614.27,288.282,614.916,288.273,615.519,288.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M221.187,267.969c-0.515,2.374,0.753,4.766,2.833,5.343l25.977,7.281 c2.301,0.652,4.228,1.098,7.22,1.233l8.179-0.542l-7.713-41.671c-17.816,11.701-19.036,12.234-35.034,25.853 C221.922,266.082,221.405,266.967,221.187,267.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M390.408,202.118l-16.319,71.159l21.346-1.534l9.748-68.959 C400.188,202.499,395.263,202.277,390.408,202.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M458.141,258.435l29.982-37.452c0.862-0.981,1.408-2.265,1.547-3.643 c0.337-3.351-1.771-6.367-4.708-6.736c-6.143-0.834-12.679-1.637-19.215-2.422"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M244.814,275.203c-5.19,0.061-9.447-4.096-9.508-9.286l0,0c-0.05-4.414,2.973-8.27,7.272-9.274 l12.523-2.936l3.186,20.985l-13.224,0.505C244.98,275.2,244.897,275.202,244.814,275.203z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    points: "254.621,274.835 258.287,274.692 255.101,253.707  251.525,254.553  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M394.992,271.747c0.154,7.375,0.074,15.176-0.723,19.162c-1.771,8.857-15.578,73.639-15.578,73.639"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M221.072,269.532c0,0,4.127,56.014,10.41,67.345c6.128,11.052,23.889,37.311,23.889,37.311"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M206.662,264.205c0,0-44.146,10.907-57.137,12.988c-10.666,1.709-54.032,12.26-67.085,17.6"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M519.804,218.163c-2.027,1.803-2.209,4.908-0.406,6.935 l5.436,5.911c0.624,0.663,1.416,1.144,2.292,1.392l66.588,18.468c1.159,0.313,2.353,0.472,3.553,0.475h13.229 c-0.688-0.459-1.392-0.884-2.128-1.277l-64.23-33.81c-0.001-0.001-0.003-0.001-0.004-0.002c-1.622-0.801-2.287-2.764-1.486-4.386 l-20.859,5.223C521.053,217.29,520.374,217.657,519.804,218.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M269.71,260.72c-0.599,0.362-7.669,7.669-7.669,7.669l1.379,9.057l8.889-9.176L269.71,260.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M280.358,279.612L280.358,279.612c-1.563,0.771-3.455,0.13-4.226-1.433l-14.104-28.577 c-0.771-1.563-0.13-3.455,1.433-4.226l0,0c1.563-0.771,3.455-0.13,4.226,1.433l14.104,28.577 C282.562,276.948,281.921,278.841,280.358,279.612z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB373"
    },
    d: "M295.747,245.214c0,0,6.997,27.915,11.098,28.968c7.43,1.909,32.999-0.228,32.5-1.053 l-1.089-12.84c0,0-25.769,4.264-25.569,3.81l-9.712-21.696L295.747,245.214z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB373"
    },
    d: "M302.182,244.089c0,0,2.299-2.139,2.362-4.735c0.063-2.596,0.804-4.652,0.718-6.584 c-0.086-1.933-1.704,0.118-2.343,1.383c-0.639,1.265-1.377,2.692-2.25,2.058c-0.872-0.634-4.669-9.097-5.979-9.838 c-1.309-0.742-1.123,0.819-1.123,0.819s-0.977-2.031-1.887-1.862c-0.236,0.044-0.715,0.529-0.415,1.524 c0.676,2.239,2.336,6.864,2.336,6.864c-0.09-0.267-2.547-5.83-3.024-6.615c-0.623-1.026-1.44-1.192-2.023-0.812 c-0.83,0.542,1.981,7.543,1.893,7.921c0,0-1.484-4.085-2.748-4.279c-1.264-0.194-0.47,2.428,0.669,4.607 c1.044,1.998,2.569,6.19,3.828,8.118c1.551,2.376,3.126,3.622,5.755,3.22 C300.581,245.475,302.182,244.089,302.182,244.089z"
  }))))))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M293.747,227.434c0.742,1.647,1.41,3.328,2,5.035"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M290.969,235.818c1.801-1.484,4.046-2.422,6.368-2.66"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M300.095,237.224c-0.799,0.515-1.411,1.316-1.698,2.222c-0.287,0.907-0.247,1.913,0.111,2.794"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M368.74,258.362c-4.681-6.181-12.109-5.562-16.935-4.714l-9.569,1.577 c-0.302,0.05-0.601,0.121-0.894,0.212l-2.183,0.679l-20.465,6.555l4.939,13.103l6.683-0.819l-1.114,1.807l6.563-0.419l0,0 l35.806-1.867c0,0,0,0,0.001-0.001l0.001-7.267C371.574,264.035,370.654,260.89,368.74,258.362z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB373"
    },
    d: "M366.804,268.672c0,0-4.495,30.111-7.669,33.3c-7.585,7.62-35.652-13.341-35.652-13.341 l0.867-8.093l24.244,10.039l4.538-25.574L366.804,268.672z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M370.493,266.62c-0.219,0.745-2.156,21.746-2.156,21.746l-20.56-1.915 c0,0,1.072-5.832,2.628-16.034c1.62-10.623,2.568-15.991,7.833-16.856C368.213,251.922,370.493,266.62,370.493,266.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M363.602,219.054c3.099,5.436,4.179,8.689,4.46,13.902c0.328,6.092,0.052,11.471-1.307,13.032 c-1.783,2.048-21.066,3.971-31.87,3.533c-0.392-0.016-0.716-3.446-0.716-3.446s-1.532,3.35-2.04,3.327 c-2.948-0.134-4.838-0.243-4.838-0.243s2.444-5.031,5.44-23.179c1.463-8.864,10.378-12.402,15.631-13.069 C357.117,211.801,363.602,219.054,363.602,219.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M337.908,236.173c-2.828-4.891-5.635-18.07,6.148-22.136 c14.709-5.075,21.297,4.306,22.561,13.602c1.265,9.296-3.976,16.321-13.696,15.617 C343.202,242.551,339.864,239.556,337.908,236.173z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB373"
    },
    d: "M358.33,236.833l-8.69,7.993l-1.673,1.782c0.464,1.259,0.851,2.552,0.984,3.793 c0.263,2.19-1.091,3.842-1.091,3.842l-1.95,4.434c4.351-3.411,14.265-5.234,14.265-5.234 C358.549,247.756,357.863,242.418,358.33,236.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M348.996,250.882c2.346-1.249,4.96-3.484,4.785-6.184c-0.082-1.137-0.276-2.22-0.515-2.92 l-4.922,5.925C348.678,248.711,348.787,249.372,348.996,250.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB373"
    },
    d: "M361.097,227.954c-1.177,8.494-1.495,12.104-6.105,16.372 c-6.933,6.421-17.014,3.685-18.376-4.851c-1.225-7.683,0.905-20.282,9.445-23.479 C354.476,212.847,362.274,219.46,361.097,227.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M350.259,230.548c-0.088,0.857-0.648,1.539-1.253,1.524 c-0.604-0.015-1.023-0.722-0.935-1.579c0.087-0.857,0.648-1.539,1.252-1.524 C349.927,228.984,350.346,229.691,350.259,230.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M341.398,229.981c-0.086,0.818-0.636,1.469-1.229,1.454c-0.593-0.015-1.005-0.69-0.919-1.508 c0.085-0.818,0.636-1.469,1.229-1.454C341.072,228.488,341.484,229.163,341.398,229.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M351.611,227.455c-0.118,0.018-0.239-0.008-0.333-0.082c-1.464-1.151-3.061-0.647-3.08-0.641 c-0.237,0.075-0.482-0.038-0.543-0.259c-0.06-0.221,0.084-0.464,0.324-0.543c0.083-0.027,2.088-0.662,3.905,0.767 c0.181,0.142,0.192,0.409,0.025,0.596C351.829,227.383,351.721,227.438,351.611,227.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M338.573,225.699c-0.092-0.049-0.164-0.129-0.194-0.232 c-0.063-0.213,0.073-0.439,0.302-0.505c2.298-0.662,3.801,0.508,3.864,0.559c0.178,0.142,0.194,0.396,0.036,0.567 c-0.157,0.171-0.429,0.195-0.607,0.054c-0.058-0.047-1.238-0.938-3.065-0.411 C338.79,225.766,338.67,225.751,338.573,225.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M354.322,220.039c-2.846,2.724-1.996,13.551,5.557,15.311 C368.751,233.692,362.816,211.909,354.322,220.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M343.277,238.053c0.645,1.101,1.384,3.211,1.384,3.211c0.203-0.033,0.406-0.065,0.607-0.108 c2.745-0.51,3.85-1.653,4.243-2.766c0.212-0.61,0.204-1.216,0.134-1.699c-0.075-0.559-0.256-0.941-0.256-0.941 c-1.294,1.14-3.816,1.812-5.179,2.115C343.641,237.997,343.277,238.053,343.277,238.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M344.21,237.864l0.432,0.936c2.585-0.486,4.339-1.175,5.003-2.11 c-0.075-0.559-0.256-0.941-0.256-0.941C348.095,236.889,345.573,237.561,344.21,237.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC5753"
    },
    d: "M345.268,241.156c2.745-0.51,3.85-1.653,4.243-2.766c-0.929,0.21-2.025,0.566-2.936,1.17 C345.877,240.019,345.492,240.599,345.268,241.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4873E"
    },
    d: "M343.817,229.493c0,0-1.785,3.77-3.549,5.574c1.042,1.105,3.015,0.641,3.015,0.641 L343.817,229.493z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M347.64,228.484l1.936,0.553C348.643,229.994,347.64,228.484,347.64,228.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M338.895,227.993l1.936,0.553C339.898,229.503,338.895,227.993,338.895,227.993z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M346.206,214.171c-3.421,0.986-7.27,6.65-7.97,8.865c4.754,1.006,17.874-2.882,17.874-2.882 s8.506,2.779,4.344-1.792C356.292,213.791,346.206,214.171,346.206,214.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB373"
    },
    d: "M363.355,235.025c-1.089,1.703-2.777,2.725-4.295,3.032c-2.284,0.462-3.282-3.223-2.406-5.449 c0.788-2.004,3.069-3.249,5.246-2.703C364.045,230.443,364.6,233.079,363.355,235.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M334.029,224.398 c-0.654,3.733-1.318,7.499-2.749,11.008c-1.431,3.509-4.401,10.746-7.647,12.702"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M358.385,237.802c-0.041,0.878,0.638,1.624,1.517,1.664c0.879,0.041,1.624-0.639,1.664-1.517 c0.041-0.878-0.638-1.624-1.517-1.664C359.171,236.245,358.426,236.924,358.385,237.802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M361.682,232.51c-0.743-0.247-1.596-0.134-2.249,0.298c-0.653,0.432-1.091,1.173-1.154,1.953"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB373"
    },
    d: "M333.887,286.141l-9.537-5.602l-2.601-3.329c0,0-2.676-3.164-4.838-3.366 c-1.543-0.145-3.139,0.654-3.139,0.654s-2.504,1.585-0.97,3.96c0,0-2.477,1.276-0.79,4.038c0,0-2.368,0.041-0.346,2.521 c2.022,2.48,4.418,2.973,6.322,3.265c1.904,0.291,4.194-0.372,4.194-0.372l10.529,6.92L333.887,286.141z"
  }), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "349.577,275.65 351.301,264.864 346.052,275.772 349.577,275.65  "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "330.316,274.953 334.607,266.241 326.368,275.437  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar1);
export default __webpack_public_path__ + "static/media/car-1.47370140c9f85fe5043991d61f51e28a.svg";
export { ForwardRef as ReactComponent };